import Modal from '../../../components/Modal/Modal';
import Cars from '../../Car/Cars';

const DealCreateCarsModal = ({ isOpen, onClose, onSubmit, onCancel, onAddCar, defaultQueryParams }) => {
  return (
    <Modal isOpen={isOpen} onRequestClose={onCancel}>
      <Cars
        header={false}
        onSubmit={onSubmit}
        onCancel={onCancel}
        onAddCar={onAddCar}
        withCheckboxes
        defaultQueryParams={defaultQueryParams || { 
          // stock: true
        }}
      />
    </Modal>
  );
};

export default DealCreateCarsModal;
